import { FastForward } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ForwardIcon = createLucideIcon(FastForward);
